import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { secondaryBlockDefaultStyles } from "../constants";

export interface HomepageBlock2Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  header?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock2 = forwardRef<HTMLDivElement, HomepageBlock2Props>(
  ({ header, content, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: secondaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-secondary"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-8 md:wb-grid lg:wb-grid-cols-2 xl:wb-grid-cols-3 md:wb-items-center">
                {content}
              </BlockSection.NestedBlock>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock2.displayName = "HomepageBlock2";
